import { render } from "./PayStatus.vue?vue&type=template&id=0d3ca0a2&scoped=true"
import script from "./PayStatus.vue?vue&type=script&lang=js"
export * from "./PayStatus.vue?vue&type=script&lang=js"

import "./PayStatus.vue?vue&type=style&index=0&id=0d3ca0a2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d3ca0a2"]])

export default __exports__